import React, { Component } from "react";
import { Modal, Button, List, Form, Row, Col, Input } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import {
  add_to_basket,
  remove_from_basket,
  clear_basket,
} from "../redux/actions/basket";
import { connect } from "react-redux";
import { createOrder } from "../services/order";

class BasketModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.formRef = React.createRef();
  }

  addItem(item) {
    const { dispatch } = this.props;
    dispatch(add_to_basket(item));
  }

  removeItem(item) {
    const { dispatch } = this.props;
    dispatch(remove_from_basket(item));
  }

  async onSubmit() {
    const { basket, setVisible, dispatch } = this.props;
    let values;
    let passed = true;
    try {
      values = await this.formRef.current.validateFields();
    } catch (err) {
      values = err.values;
      passed = false;
    }

    values["order_items"] = basket.map((item) => {
      const key_name = item.type === "MEAL" ? "meal_id" : "item_id";
      return {
        [key_name]: item.id,
        amount: item.amount,
        type: item.type,
        name: item.name,
        unit: item.unit,
      };
    });

    values["type"] = "SELL";
    if (values["description"] === "") {
      values["description"] = "-";
    }
    if (passed) {
      // Get room from query param in url
      let regex = /[?&]([^=#]+)=([^&#]*)/g,
        params = {},
        match;
      while ((match = regex.exec(window.location.href))) {
        params[match[1]] = match[2];
      }
      await createOrder(values, params.room);
      dispatch(clear_basket());
      setVisible(false);
    }
  }

  render() {
    const { visible, setVisible, basket, totalPrice } = this.props;

    return (
      <Modal
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        onOk={this.onSubmit}
        width={"100vw"}
        height={"100vh"}
        title={"ตะกร้า"}
        okText={"ยืนยันการสั่ง"}
        cancelText={"กลับ"}
        keyboard={false}
        maskClosable={false}
        destroyOnClose={true}
      >
        <List
          size="large"
          dataSource={basket}
          bordered
          renderItem={(item, idx) => (
            <List.Item
              //   style={{
              //     borderBottom:
              //       idx === basket.length - 1 ? undefined : "1px solid grey",
              //   }}
              actions={[
                <Button
                  type="success"
                  shape="circle"
                  size="small"
                  onClick={() => this.addItem({ ...item, amount: 1 })}
                >
                  <PlusOutlined />
                </Button>,
                <span> {item.amount}</span>,
                <Button
                  type="danger"
                  shape="circle"
                  size="small"
                  onClick={() => this.removeItem(item)}
                >
                  <MinusOutlined />
                </Button>,
              ]}
            >
              {item.name}
            </List.Item>
          )}
        />
        <br/>
        <Form
          ref={this.formRef}
          layout={"vertical"}
          initialValues={{ description: "" }}
        >
          <Row gutter={12}>
            <Col span={24}>
              <Form.Item hasFeedback label="คำขอเพิ่มเติม" name="description">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div style={{display: 'flex', justifyContent: "flex-end", fontSize: 16}}><span>ราคารวม: {totalPrice} บาท</span></div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return { basket: state.basket.basket, totalPrice: state.basket.totalPrice };
}

export default connect(mapStateToProps)(BasketModal);
